import {Component, computed, Signal, signal} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {FirstPageComponent} from "./first-page/first-page.component";
import {MatButton} from "@angular/material/button";
import {Router} from "@angular/router";
import {SecondPageComponent} from "./second-page/second-page.component";
import {ThirdPageComponent} from "./third-page/third-page.component";
import {FourthPageComponent} from "./fourth-page/fourth-page.component";
import {FifthPageComponent} from "./fifth-page/fifth-page.component";
import {OnboardingService} from '../../services/onboarding.service';
import {OnboardingData} from '../../services/models/onboarding-data';
import {UserOnboardingStatusService} from '../../services/user-onboarding-status.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-onboarding',
  imports: [TranslocoDirective, FirstPageComponent, MatButton, SecondPageComponent, ThirdPageComponent,
    FourthPageComponent, FifthPageComponent],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent {
  onboardingData: Signal<OnboardingData>;
  currentPage = 1;
  maxPages = 5;

  allPlacesCount = computed(() => this.onboardingData()!.loyaltyLevelAggregations
    .map(agg => agg.count)
    .reduce((a, b) => a + b, 0));

  constructor(private router: Router, onboardingService: OnboardingService,
              private userOnboardingStatusService: UserOnboardingStatusService) {
    this.onboardingData = toSignal(onboardingService.getOnboardingData()) as Signal<OnboardingData>;
  }

  goToNextPage() {
    this.currentPage++;
  }

  goBack() {
    if (this.currentPage > 1) {
      this.currentPage--;
    } else {
      const _ = this.router.navigate(['/']);
    }
  }

  markOnboardingStatusAsDisplayed(): void {
    this.userOnboardingStatusService.markUserOnboardingStatusAsDisplayed()
      .subscribe(() => {
        const _ = this.router.navigate(['/']);
      });
  }
}
